/**
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'underscore',
	'./AbstractTupleLocator'
], function (_, AbstractTupleLocator) {
	class SelectorTupleLocator extends AbstractTupleLocator {

		/**
		 * A tuple locator which tries points based on elements found by a CSS
		 * selector. This is not the most robust approach, use it only as needed.
		 */
		constructor({ $el, selector, viprWidget }) {
			super();
			this.$el = $el;
			this.selector = selector;
			this.viprWidget = viprWidget;
		}

		findTupleVisualInfo(filter, { includeInfo, includePoints }) {
			//Query selector to get elements, and thus candidate points
			const matches = this.$el.find(this.selector)
				.toArray()
				.map(e => this._getPoint(e))
				.map(point =>
					this._getItemsAtCenterOfElement(point).map(
						item => {
							//Get info from item
							const info = this._getValueInfoFromItem(item);

							//Filter items according to specified filter
							if(this._itemSatisfiesFilter({ item, filter })) {
								const result = {};
								if(includeInfo) {result.info = info;}
								if(includePoints) {result.point = point;}
								return result;
							}
						}
					).filter(result => !!result)
				);

			return _.flatten(matches);
		}

		_getPoint(e) {
			const { left, top, width, height } = e.getBoundingClientRect();
			return {
				selectedNode: e,
				left,
				top,
				xOffset: width/2,
				yOffset: height/2
			};
		}

		_getItemsAtCenterOfElement({ left, top, xOffset, yOffset }) {
			const coord = this.viprWidget.getVisCoordinate(left + xOffset, top + yOffset);
			return this.viprWidget.getItemsAtPoint(coord);
		}

	}

	return SelectorTupleLocator;
});
